import Image from "./Image";
import YoutubeVideo from "./YoutubeVideo";
import Audio from "./Audio";
import Text from './Text';
import FIBText from './FIBText';
import TextAndAudio from './TextAndAudio';
import TextAndImage from './TextAndImage';
import TextAndVideo from "./TextAndVideo";
import HTML from './HTML';

export const renderers = {
    'image': Image,
    'youtubeVideo': YoutubeVideo,
    'audio': Audio,
    'text': Text,
    'fib-text': FIBText,
    'text-and-audio': TextAndAudio,
    'text-and-image': TextAndImage,
    'text-and-video': TextAndVideo,
    'html': HTML,
}